<google-map [center]="center" [zoom]="16">
  <map-marker [position]="center" [options]="{draggable: false}"></map-marker>
  <map-info-window>{{ markerTitle }}</map-info-window>
</google-map>
